module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/sp/profile_page/profile_image-a5679faede550408fe27c74f321126ab.png";